import { render, staticRenderFns } from "./labelled_value.vue?vue&type=template&id=efe2e15c&scoped=true&lang=pug"
import script from "./labelled_value.vue?vue&type=script&lang=js"
export * from "./labelled_value.vue?vue&type=script&lang=js"
import style0 from "./labelled_value.vue?vue&type=style&index=0&id=efe2e15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe2e15c",
  null
  
)

export default component.exports